import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";

import Buy from "../../../../Assets/Logo/buy.png";
import Rent from "../../../../Assets/Logo/rent.png";
import Publish from "../../../../Assets/Logo/publish.png";
import Sell from "../../../../Assets/Logo/sell.png";
import { useStyles } from "./WorkList.css";

class WorkList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workList: [
        {
          name: "Publish Your Book",
          description: "We encourage new writers to publish their books",
          icon: (
            <img
              src={Publish}
              alt="Publish"
              style={{ width: 70, height: 70 }}
            />
          ),
          url: "/book/publish",
          buttonLabel: "Publish Book",
          role: "Author",
        },
        {
          name: "Buy Book",
          description: "Buy books digitally",
          icon: <img src={Buy} alt="Buy" style={{ width: 70, height: 70 }} />,
          url: "/books",
          buttonLabel: "Buy Book",
          role: "User",
        },
        {
          name: "Rent Book",
          description: "Let's rent book",
          icon: <img src={Rent} alt="Rent" style={{ width: 70, height: 70 }} />,
          url: "/books",
          buttonLabel: "Rent Book",
          role: "User",
        },
        {
          name: "Sell Book",
          description: "Sell your book",
          icon: <img src={Sell} alt="Sell" style={{ width: 70, height: 70 }} />,
          url: "/book/publish",
          buttonLabel: "Sell Book",
          role: "Author",
        },
      ],
    };
  }

  render() {
    const { classes } = this.props;
    let userList = this.state.workList.filter((data) => data.role === "User");
    let authorList = this.state.workList.filter(
      (data) => data.role === "Author"
    );
    let filteredList = this.props.isAuth
      ? userList
      : this.props.isAuthor
      ? authorList
      : this.state.workList;
    return (
      <Grid container className={classes.gridRoot}>
        {filteredList.map((work, index) => (
          <Grid item container xs={12} sm={12} md={6} xl={3} lg={3} key={index}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              xl={12}
              lg={12}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <Avatar className={classes.avatarStyle}>{work.icon}</Avatar>
              <div
                style={{
                  textAlign: "center",
                  fontSize: 25,
                  fontWeight: "bold",
                }}
              >
                {work.name}
              </div>
              <div
                style={{
                  textAlign: "center",
                  padding: 10,
                  fontSize: 18,
                }}
              >
                {work.description}
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              xl={12}
              lg={12}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Button
                disableRipple
                variant="outlined"
                className={classes.buttonStyle}
                onClick={() => this.props.history.push(`${work.url}`)}
              >
                {work.buttonLabel}
              </Button>
            </Grid>
          </Grid>
        ))}
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    isAuthor: state.AuthorReducer.isAuthor,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(WorkList)));
